import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';

export default function ReplyModal({ isOpen, onClose, onReply, review }) {
  const [reply, setReply] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reply.trim()) return;
    setLoading(true);
    await onReply(reply);
    setLoading(false);
    setReply('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-full max-w-lg">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold">Reply to Review</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
            <FiX className="w-5 h-5" />
          </button>
        </div>
        
        {review && (
          <div className="p-6 border-b bg-gray-50">
            <div className="flex items-center mb-2">
              <p className="font-medium">{review.user_name}</p>
              <div className="ml-2 flex items-center text-yellow-500">
                <FiStar className="fill-current" />
                <span className="ml-1 text-sm">{review.rating}</span>
              </div>
            </div>
            <p className="text-gray-600">{review.comment}</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="p-6">
          <textarea
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            placeholder="Write your reply..."
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary-500"
            required
          />
          
          <div className="flex justify-end space-x-3 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !reply.trim()}
              className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send Reply'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
